<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'default',
})
</script>
<template>
    <div v-if="data">
      <div v-if="data.pic"class="bg-img  box-shadow" :style="{backgroundImage: 'url('+addip(data.pic)+')',height:height+'px',marginBottom:'50px',padding:'30px'}">
        <contenttitle :data="data"  class="text-white"></contenttitle>
      </div>
      <contenttitle :data="data" v-else></contenttitle>
    </div>
</template>
<script setup lang="ts" name="default">
import {defineComponent,defineProps } from 'vue';
import {addip,getCol} from '@/utils/util'
import {ArrowRightOutlined} from '@ant-design/icons-vue'
defineProps({
  data:Object,
  height:{type:Number,default:480}
})
</script>
